import React, {useState} from 'react';

import {ProfileIcon} from '~/Components/Icons/Icons'
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {produce} from 'immer';
import {adminHttp} from "~/Admin/services/http";


const AdminRegistrationTickets = ({guests, match, event, ...props}) => {

    if (!guests) {
        return <></>;
    }

    let defaultForm = {};
    guests.forEach((guest) => {
        defaultForm[guest.id] = guest.ticket?.ticket_ref || '';
    });

    const [form, setForm] = useState(defaultForm);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState(null);

    const handleChange = (e, guest) => {
        const value = e.target.value;

        setForm(produce(form, (draft) => {
            draft[guest.id] = value;
        }));
    };

    const handleSubmit = () => {

        adminHttp
            .post('/events/' + event.id + '/guests/tickets', {
                'data': form
            })
            .then(res => {
                setSuccess('Ticket references has been updated!');
                setError(null);
            }).catch((error) => {
                setSuccess('');
                setError(error.response?.data);
            });
    };

    return (

        <div>
            <div className="row mt-4">
                <div className="col-12">
                    <h2 className="mb-3">Assign Tickets</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-12">

                    {success && (
                        <div className="alert alert-success" role="alert">
                            {success}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving tickets!"}
                        </div>
                    )}

                    <table className="table">
                        <tbody>
                        {guests.map((guest, index) => (
                            <tr key={guest.id}>
                                <td className="align-middle">
                                    <ProfileIcon color="#999BB5" classes="d-inline mr-2"/>
                                    <span
                                        className="text-muted">{guest.main ? 'Main Guest' : 'Guest ' + (index + 1)}</span>
                                </td>
                                <td className="text-right align-middle">
                                    Ticket Ref
                                </td>
                                <td className="align-middle">
                                    <input
                                        onChange={(e) => handleChange(e, guest)}
                                        value={form[guest.id]}
                                        name="ticker_ref"
                                        type="text"
                                        className="form-control"/>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-12 text-right">
                    <button className="btn btn-primary" onClick={handleSubmit}>SUBMIT</button>
                </div>
            </div>

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(withRouter(AdminRegistrationTickets));
